import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class HrCacheService {
    private cache = new Map<string, { data: any, timestamp: number }>();

    constructor() {}

    // Get cached data by key
    getCache(key: string): any {
        const cached = this.cache.get(key);
        if (cached) {
            return cached.data;
        }
        return null;
    }

    // Set cached data by key
    setCache(key: string, data: any): void {
        this.cache.set(key, {
            data,
            timestamp: Date.now()
        });
    }

    // Check if cache is expired
    isCacheExpired(key: string, ttl: number): boolean {
        const cached = this.cache.get(key);
        if (cached && (Date.now() - cached.timestamp) < ttl) {
            return false;
        }
        this.cache.delete(key); // Remove expired cache
        return true;
    }
}
